import { render, staticRenderFns } from "./statisticalAnalysis.vue?vue&type=template&id=5dc80e4c&"
import script from "./statisticalAnalysis.vue?vue&type=script&lang=js&"
export * from "./statisticalAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports